import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { MessageHandlerDeps } from '../../routing/message-handler-deps.js';
import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import { readPersistedQueue } from '../disk-store.js';
import { finalizePromptTurnOnBridge } from './finalize-prompt-turn-on-bridge.js';
import type { PromptQueueSnapshotEntries } from './prompt-queue-snapshot-types.js';

export async function handlePromptQueueCancellations(
  entries: PromptQueueSnapshotEntries,
  deps: MessageHandlerDeps,
): Promise<void> {
  for (const [queueKey] of entries) {
    const file = await readPersistedQueue(queueKey);
    const turn = file?.turns.find((row) => row.bridgeServerState === 'cancel_requested' && row.lastCliState === 'running');
    if (!turn) {
      await yieldToEventLoop();
      continue;
    }
    deps.log(`[Queue] Cancellation request received for turn ${turn.turnId.slice(0, 8)}…`);
    if (await deps.acpManager.cancelRun(turn.turnId)) {
      await yieldToEventLoop();
      continue;
    }
    deps.log(`[Queue] cancel_requested for ${turn.turnId.slice(0, 8)}… with no local run; marking cancelled.`);
    await finalizePromptTurnOnBridge(deps.getWs, turn.turnId, false, { terminalCliState: 'cancelled' });
    const ws = deps.getWs();
    if (ws && turn.sessionId) {
      sendWsMessage(ws, {
        type: 'prompt_result', sessionId: turn.sessionId, runId: turn.turnId,
        success: false, error: 'Stopped by user', stopReason: 'cancelled',
      });
    }
    await yieldToEventLoop();
  }
}
